import React from 'react';

import CSSModules from 'react-css-modules';

import type {BaseObject, CanvasMedia, ProcessStatus} from '../../types';

import styles from '../styles.module.scss';

export type Choice = {
  id: string;
  text: string | null;
  type: string | null;
  cover: CanvasMedia | null;
  content: CanvasMedia | null;
  isCorrect?: boolean;
  processStatus: ProcessStatus | null;
};

interface PollObjectProps<T extends BaseObject> {
  object: Extract<T, {type: 'poll'}>;
  setSelectedObject: (object: T) => void;
}

const PollObjectComponent = <T extends BaseObject>({
  object,
  setSelectedObject,
}: PollObjectProps<T>) => (
  <div
    styleName='poll-widgets'
    onClick={() => {
      setSelectedObject(object);
    }}
  >
    <div styleName='poll-widgets-head'>{object.text}</div>
    <div styleName='poll-widgets-body'>
      {object.choices?.map((choice) => (
        <div key={choice.id} styleName={'poll-item'}>
          {choice.text}
        </div>
      ))}
    </div>
  </div>
);

export const PollObject = CSSModules(PollObjectComponent, styles);
